<template>
    <div class="component__b2b--maintenance-plan-html">
        <section class="topo">
            <div>
                <base-button-back class="p-0" @click="exitDocument">{{$t('back')}}</base-button-back>
            </div>
            <div class="print print_btn text-center d-flex justify-center align-center" @click="print">
                <img class="mr-2" src="/images/_SVGs/print.svg" onload="SVGInject(this)"  />
                <h5 class="text-printer">{{$t('print')}}</h5>
            </div>
        </section>

        <section id="print-page" class="box-print-page">
            <div class="component__b2b--maintenance-plan-html-only-html" v-html="pageHtml"></div>
        </section>
    </div>
</template>

<script>
import {QuotationServicesGetMaintenancePlanHtml} from '@services/b2b/quotation/QuotationServices.js';
import {
    TechInfoServicesGetAdjustHtmlFromItemMpId,
    TechInfoServicesGetAdjustSubGroupHtml,
    TechInfoServicesGetLinkedTechnicalManuals,
    TechInfoServicesGetMaintenancePlanHtml,
    TechInfoServicesGetManualsFromManualID,
    PrintTechnicalInformationManual,
} from '@services/b2b/tech-info/TechInfoServices';
import {Base64} from 'js-base64';
/**
 * Biblioteca para acionar a funcionalidade print do browser
 */
import BaseButtonBack from "@components/shared/widgets/BaseButtonBack.vue";

export default {
    components: {BaseButtonBack},
    data() {
        return {
            logo: '',
            pageHtml: '',
            oldHtml: '',
            firstHtml: '',
            countPageChange: 0
        };
    },
    props: {
        show: {
            type: Boolean,
            required: false
        },
        hasQuotation: {
            type: Boolean,
            required: true
        },
        id: Number | [Number],
        callRmi: { type: Boolean, required: false },
        rmiId: { type: String | Number, required: false },
    },
    computed: {
      getShowLoadingTemplate() {
        return this.$store.getters['loadings/getLoadingState'].loadings.showLoadingTemplate.show;
      },
    },
    methods: {
        exitDocument() {
            if(this.pageHtml != this.firstHtml) {
              this.pageHtml = this.firstHtml;
              return;
            } else {
              this.$store.commit('budget/setB2b', { maintenancePlanHtml: { show: false, id: 0 } });
              this.$store.commit('techInfo/setTechInfo', { maintenancePlanHtml: { show: false, id: 0 } });
            }
        },
        print() {
            this.$store.commit("loadings/setStateLoadingTemplate", true);

            const pickCheckBoxesNot = document.querySelectorAll("input[type='checkbox']:not(:checked)");
            const pickCheckBoxes = document.querySelectorAll("input[type='checkbox']:checked");
            const pickDateInput = document.querySelectorAll("input[type='date']");
            const pickNumberInput = document.querySelectorAll("input[type='number']");

            for (let element of pickCheckBoxesNot) {
                $(element).attr('checked', false);
            }
            for (let element of pickCheckBoxes) {
                $(element).attr('checked', true);
            }
            for (let element of pickDateInput) {
                $(element).attr('value', element.value);
            }
            for (let element of pickNumberInput) {
                $(element).attr('value', element.value);
            }

            const updatedHtml = document.getElementById("print-page").innerHTML;
            const body = {
                filename: `MaintenancePlan_${this.$store.getters["vehicleIdentification/getState"].plateNumber}.pdf`,
                base64: Base64.encode(updatedHtml)
            };

            return PrintTechnicalInformationManual(body)
                .then(response => {
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    window.open(link);
                })
                .catch(error => {
                    console.error("Error in print request:", error);
                    this.$requestStatus.checkRequestStatus(error.response?.status, this.$route.name);
                })
                .finally(() => {
                    this.$store.commit("loadings/setStateLoadingTemplate", false);
                });
        },
        getMaintenance(callback) {
            if (this.show) {
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                callback(this.id, {})
                    .then(response => {
                        this.pageHtml = Base64.decode(response.data.result);
                        this.firstHtml = Base64.decode(response.data.result);
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        console.error('MaintenancePlanHtml', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    });
            }
        },
        clickOnElement(fullItemMpId) {
            let type = Array.from(fullItemMpId)[0];
            var itemMpId = fullItemMpId.substring(1);
            if(type == 'a') {
                // itemHTML
                this.getAdjustHtmlFromItemMpId(itemMpId);
            } else if(type== 'i') {
                // linkedTechnicalmanuals
                this.getLinkedTechnicalManuals(itemMpId);
            }
        },
        // Gets the adjust item mp identifier
        getAdjustHtmlFromItemMpId(id) {
            this.$store.commit("loadings/setStateLoadingTemplate", true);
            return TechInfoServicesGetAdjustHtmlFromItemMpId(id)
                .then((response) => {
                    const removeFirst = Base64.decode(
                        response.data.result
                    ).substring(1);
                    this.pageHtml = removeFirst.slice(0, -1);
                })
                .catch((error) => {
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    this.modalInfo.showMessage = true;
                    throw new Error(
                        "error to get the adjust item mp identifier - tech info b2b",
                        error
                    );
                })
                .finally(() => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                });
        },
        getLinkedTechnicalManuals(id) {
            this.$store.commit("loadings/setStateLoadingTemplate", true);

            let body = {
                itemMpIds: [id],
            };
            // 27-07-2021
            if (id == 2713) {
                body = {
                    itemMpIds: [id, "2714", "2715", "19454", "19586"],
                };
            }

            return TechInfoServicesGetLinkedTechnicalManuals(body)
                .then((response) => {
                    if (
                        (response.data.result &&
                            response.data.result.length <= 1 &&
                            response.data.result[0] == null) ||
                        !response.data.result
                    ) {
                        this.modalInfo.showMessage = true;
                        return;
                    }

                    let res = response.data.result;
                    res = res.filter((e) => e !== null);

                    this.getManualsFromManualID(
                        res[0].manuals[0].manualId
                    );
                })
                .catch((error) => {
                    this.modalInfo.showMessage = true;
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    throw new Error(
                        "error to gets the linked technical manuals - tech info b2b",
                        error
                    );
                })
                .finally(() => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                });
        },
        // Gets the manuals from manual identifier
        getManualsFromManualID(id) {
            this.$store.commit("loadings/setStateLoadingTemplate", true);
            return TechInfoServicesGetManualsFromManualID(id)
                .then((response) => {
                    const removeFirst = Base64.decode(
                        response.data.result
                    ).substring(1);
                    this.pageHtml = removeFirst.slice(0, -1);
                })
                .catch((error) => {
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    this.modalInfo.showMessage = true;
                    throw new Error(
                        "error to get the manuals from manual id - tech info b2b",
                        error
                    );
                })
                .finally(() => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                });
        },
        getRmiManual(rmiIdentifier) {
          this.$store.commit("loadings/setStateLoadingTemplate", true);
            return TechInfoServicesGetAdjustSubGroupHtml(rmiIdentifier)
                .then((response) => {
                    const removeFirst = Base64.decode(response.data.result).substring(1);
                    const removeLast = removeFirst.slice(0, -1);
                    this.pageHtml = removeLast;
                    this.firstHtml = removeLast;
                })
                .catch((error) => {
                    this.$requestStatus.checkRequestStatus(
                      error.response.status,
                      this.$route.name
                    );
                    throw new Error("error to get the adjust sub group html - tech info b2b", error);
                })
                .finally(() => {
                  this.$store.commit("loadings/setStateLoadingTemplate",false);
                });
        }
    },
    watch: {
        show(newItem, oldItem) {
            if (newItem) {
              if(this.callRmi) {
                this.getRmiManual(this.rmiId)
              } else {
                this.getMaintenance(this.hasQuotation ? QuotationServicesGetMaintenancePlanHtml : TechInfoServicesGetMaintenancePlanHtml);
              }
            } else {
              this.pageHtml = '';
            }
        },
        pageHtml: {
          handler: function (val, oldVal) {
            this.countPageChange++;
            if(oldVal) {
              this.oldHtml = oldVal;
            }
            if (val) {
              this.$nextTick(() => {
                  $("#pageBody")
                      .find("a")
                      .each(function () {
                          let hrefValueWithNumericsOnly = $(this).attr("href");
                          if(hrefValueWithNumericsOnly){
                              hrefValueWithNumericsOnly = hrefValueWithNumericsOnly.substring(1, hrefValueWithNumericsOnly.length-1);
                              const functionWithRightId = `javascript:clickOnElement('${hrefValueWithNumericsOnly}')`;
                              $(this).attr("href", functionWithRightId);
                          }
                      });
              });
            } else {
              this.countPageChange = 0;
              this.oldHtml = '';
            }
          },
          deep: true,
          immediate: true
        }
    },
    mounted() {
        if(this.callRmi) {
          this.getRmiManual(this.rmiId)
        } else {
          this.getMaintenance(this.hasQuotation ? QuotationServicesGetMaintenancePlanHtml : TechInfoServicesGetMaintenancePlanHtml);
        }
    },
    created() {
        window.clickOnElement = this.clickOnElement.bind(this);
    },
};
</script>

<style lang="scss">
@import '@sass/_variables.scss';

.component__b2b--maintenance-plan-html {
    background-color: white;
    padding: 10px;
    .topo {
        display: flex;
        justify-content: space-between;
        margin-bottom: 30px;

        .back {
            display: flex;
            align-items: center;
            cursor: pointer;
            font-family: Lato;

            div {
                &:last-child {
                    margin-left: 10px;
                    color: var(--v-primary-base);
                    transition: ease $animations-time-duration;
                }
            }

            svg {
                rect {
                    transition: ease $animations-time-duration;
                }
            }

            &:hover {
                svg {
                    rect {
                        fill: $orange;
                    }
                }

                div {
                    &:last-child {
                        margin-left: 10px;
                        color: $orange;
                    }
                }
            }
        }

        .print {
            display: flex;
            align-items: center;
            cursor: pointer;
            color: var(--v-primary-base);

            .icon-printer {
                background-color: var(--v-primary-base);
                border-radius: 4px;
                padding: 2px 0;
                color: $white;
                transition: ease $animations-time-duration;
            }

            .text-printer {
                color: var(--v-primary-base);
                margin-left: 0px;
                font-family: Lato;
                transition: ease $animations-time-duration;
            }

            &:hover {
                .icon-printer {
                    filter: brightness(0.8);
                }

                .text-printer {
                    filter: brightness(0.8);
                }
            }
        }
    }

    #print-page {
        margin-top: 40px;
        margin-top: 50px;
        height: calc(100vh - 210px);
        overflow: auto;
    }
}
</style>
